import ALERT_CONSTS from 'cyberint-alert-consts';

const ALERT_SUBTYPES = ALERT_CONSTS.AlertSubType;
const {
  COMPANY_CUSTOMER_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED
} = ALERT_SUBTYPES;

export const TABLE_SUBTYPES_MAP = {
  COMPANY_CUSTOMER_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED
};

export const TABLE_SUBTYPES = Object.values(TABLE_SUBTYPES_MAP);

export const EMPLOYEE_CREDS_SUBTYPES = [
  COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED
];
